import { MutationTree } from 'vuex'

import { NoticeState } from '@/types/store'
import { INotice } from '@/types/notice'

export const mutations: MutationTree<NoticeState> = {
  setIsNoticesLoading(state, isNoticesLoading: boolean) {
    state.isNoticesLoading = isNoticesLoading
  },
  noticesLoaded(state, notices: INotice[]) {
    state.notices = notices
  },
  setNotice(state, notice: INotice) {
    state.notice = notice
  },
  createNotice(state, payload: NoticeState['notice']) {
    state.notices.push(payload)
  },
  updateNotice(state, payload: NoticeState['notice']) {
    if (!state.notices) return
    const noticeIndex = state.notices.findIndex(
      notice => notice.id === payload.id,
    )
    state.notices.splice(noticeIndex, 1, payload)
  },
  deleteNotice(state, id: number) {
    if (!state.notices) return
    const noticeIndex = state.notices.findIndex(notice => notice.id === id)
    state.notices.splice(noticeIndex, 1)
  },
}
